import { MapsAPILoader } from '@agm/core';
import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { number } from 'ngx-custom-validators/src/app/number/validator';
import { NgxSpinnerService } from 'ngx-spinner';
import { Toast, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-client-add',
  templateUrl: './client-add.component.html',
  styleUrls: ['./client-add.component.scss']
})
export class ClientAddComponent implements OnInit {

  @ViewChild("search")
  public searchElementRef: ElementRef;

  address: string;
  latitude: number;
  longitude: number;
  zoom: number;
  private geoCoder;

  client_id:any

  client_model ={
    name: '',
    email: '',
    password: '',
    phone: '',
    dob: '',
    sex: '',
    client_address: '',
    linkedIn: '',
    clientcode: '',
    clienttype: '',
    history: '',
    businessId: [],
    source: '',
    source_link:'',
    frequency: '',
    bankinfo: '',
    documents: '',
    notes: '',
    admin_notes: '',
    client_representive: '',
    lead:[],
    contract:[],
    project:[],
    product:[]
  }
  gender_list =[
    { name:'Male',_id:'male'},
    { name:'Female', _id:'female'}
  ]
  selected_gender='male'
  business_list =[]
  selected_business=null
  currentUrl:any
  channel_cat_id='63f89909c3648e0879c3e05a'
  channel_list=[]
  selected_channel=null
  countryCodes = [
    { label: '+91', value: '+91' },
    { label: '+1', value: '+1' },
    { label: '+44', value: '+44' }
  ];
  selected_code ='+91'
  emp_list =[]
  constructor(public apiService: ApiService, private mapsAPILoader: MapsAPILoader,
              private ngZone: NgZone,public toastr: ToastrService,private router :Router,
              private activatedroute: ActivatedRoute,private spinner: NgxSpinnerService,) { 
                // this.locationAutoComplete()
                this.currentUrl=this.activatedroute.snapshot.routeConfig.path
                this.activatedroute.paramMap.subscribe(params => {
                this.client_id = params.get('id');
                })
              }

  ngOnInit(): void {
    this.client_model.client_representive = null
    this.getChannelsList()
    this.getFullTimeEmpList()
    if(this.client_id){
      this.getClientById(this.client_id)
    }
  }

  getFullTimeEmpList(){
    this.apiService.getEmployeeList(1,100).subscribe((res:any)=>{
      this.emp_list = res?.items
    })
  }
  getEmpId(event){
    this.client_model.client_representive
  }
  getChannelsList(){
    this.apiService.getTagByTagCatgoryId(this.channel_cat_id).subscribe((res:any)=>{
      this.channel_list =res.data
      
    })
  }
  getChannelId(event){
    this.client_model.clienttype = this.selected_channel
  }
  getAllBusiness(event,data){
    let name = event.term?event.term: data
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getBusinessSearch(name).subscribe((res:any)=>{
      this.spinner.hide()
      this.business_list = res?.data
    })
  }

  getGenderId(event){
    this.selected_gender
    this.client_model.sex =  this.selected_gender
  }
  getBusinessId(event){
    this.selected_business
    this.client_model.businessId = this.selected_business
  }
  getClientById(id){
    this.apiService.getClientById(id).subscribe((res:any)=>{
      this.client_model.name = res?.data[0]?.user_id[0]?.name
      this.client_model.email = res?.data[0]?.user_id[0]?.email
      this.client_model.phone = res?.data[0]?.user_id[0]?.phone
      this.client_model.dob = res?.data[0]?.user_id[0]?.dob
      this.selected_gender = res?.data[0]?.user_id[0]?.sex
      this.client_model.sex =  this.selected_gender
      this.client_model.linkedIn = res?.data[0]?.user_id[0]?.linkedIn
      this.client_model.clientcode = res?.data[0].clientcode
      this.client_model.history = res?.data[0].history
      this.selected_business = res?.data[0]?.businessId[0]?._id
      this.client_model.businessId =  this.selected_business
      this.getAllBusiness('',res?.data[0]?.businessId[0]?.name)
      this.client_model.client_address = res?.data[0]?.client_address
      this.client_model.source = res?.data[0]?.source
      this.client_model.source_link = res?.data[0]?.source_link
      this.client_model.bankinfo= res?.data[0]?.bankinfo
      this.client_model.documents = res?.data[0]?.documents
      this.client_model.notes= res?.data[0]?.notes
      this.client_model.admin_notes = res?.data[0]?.admin_notes
      this.client_model.client_representive = res?.data[0]?.client_representive[0]?._id
      this.selected_channel = res?.data[0]?.clienttype[0]?._id
      this.client_model.clienttype = this.selected_channel
    })
  }
  submit(){
    // let phone = this.selected_code + this.client_model.phone
    // this.client_model.phone = phone
    this.client_model.sex =  this.selected_gender
    // console.log(this.client_model)
    if(!this.client_id){
      this.apiService.addClient(this.client_model).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          this.toastr.success(res?.message)
          this.router.navigate(['/clients/lists'])
        }
        else this.toastr.error(res?.error)
      })
    }
    if(this.client_id){
      this.apiService.updateClient(this.client_id,this.client_model).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          this.toastr.success('update successfull')
          this.router.navigate(['/clients/lists'])
        }
        else this.toastr.error(res?.error)
      })
    }
  }


  locationAutoComplete() {
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder;
  
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef?.nativeElement);
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          this.address = place.formatted_address;
          // this.client_model.address = this.address
          console.log('address', this.address)
          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
  
          // set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          // this.client_model.lat = this.latitude
          // this.client_model.lng = this.longitude
          this.zoom = 12;
          // if(this.client_id){
          //   this.address = place.formatted_address;
          //   this.latitude = place.geometry.location.lat();
          //   this.longitude = place.geometry.location.lng();
          //   // this.employee.address = this.address
          //   // this.employee.lat = this.latitude
          //   // this.employee.lng = this.longitude
  
          // }
          console.log("lat lng",this.latitude,this.longitude)
        });
      });
    });
  }
  inlineAddupdateBody(data ,prop) {
    if (prop == 'notes') {
        this.client_model.notes =data
      }
    if(prop == 'admin_notes') {
      this.client_model.admin_notes =data
    }

  }
}
